import { UnknownArrayType } from '../components'

export const isArrayWithLength = (array?: UnknownArrayType) =>
  (array && array.length > 0) || false
